/**
 * 当前 L7 内部存在的地图版本
 */
export enum Version {
  'GAODE1.x' = 'GAODE1.x',
  'GAODE2.x' = 'GAODE2.x',
  'MAPBOX' = 'MAPBOX',
  'L7MAP' = 'L7MAP',
  'SIMPLE' = 'SIMPLE',
  'GLOBEL' = 'GLOBEL',
}
